import React, {useEffect, useRef, useState} from 'react';
import {withAlert} from '../react-alert-master/src'
import ReactTooltip from "react-tooltip";
import {Clean, Datasource, Doc, Open, Page, Save, SaveForce, SaveHtml, isUUID} from './Functions/funcs';
import html2canvas from '../html2canvas/dist/html2canvas';
import {ControlledMenu, MenuButton, MenuDivider, MenuItem, useMenuState} from '../react-menu/dist';
import '../react-menu/dist/index.css';
import '../react-menu/dist/transitions/slide.css';
import objeler from './objeler';
import $ from 'jquery';
import axios from "axios";
import store from "../redux/store";
import axiosInstance from './token/axiosInstance'
import { openTemplateLibrary } from '../redux/actions/templateActions';
import { openV2Dashboard } from '../redux/actions/v2DashboardActions';
const btnMenuClass = 'inline-block bg-customWhite text-sm px-4 py-2 leading-none border-btn  border-customGray rounded  text-gray-600    hover:border-customGray1  hover:bg-blue-50 hover:bg-text-red mt-1 lg:mt-2 ';
const btnZoomClass = 'inline-block bg-customWhite  text-sm px-2 py-1 leading-none border-btn  border-customGray rounded  text-gray-600 border-gray-600 hover:border-customGray1  hover:bg-blue-50 hover:bg-text-red mt-1 lg:mt-2 ';
const btnZoom100Class = 'inline-block bg-customWhite  text-sm px-2 py-0 leading-none border-btn  border-customGray rounded  text-gray-600 border-gray-600 hover:border-customGray1  hover:bg-blue-50 hover:bg-text-red mt-1 lg:mt-2 ';
const btnMenuItemClass = '  hover:bg-blue-50 ';
const btnMenuTextClass = "text-sm text-gray-600";
const btnMenuIconSize = "1.4em";
const btnMenuIconWidth = "26px";
const toolTipClass = 'text-md px-2 py-2 leading-none mt-3  '
const logo = require('../assets/wdoclogo7.png').default;
const pdficon = require('../assets/fontpdfpdf2.gif').default;
const btnZoomClassFullScreen = ' inline-block bg-customWhite  text-sm px-2 py-1 leading-none border-btn  border-customGray rounded  text-gray-600 border-gray-600 hover:border-customGray1  hover:bg-blue-50 hover:bg-text-red mt-1 lg:mt-2 ';
const Header = (props) => {
    const toolRef = useRef(null);
    const innerRef = useRef(null);
    const innerRefExit = useRef(null);
    const [DocMenuState, setDocMenuState] = useState('closed');
    const [PageMenuState, setPageMenuState] = useState('closed');
    const [mCord, setmCord] = useState(false);
    const refDocMenu = useRef(null);
    const refPageMenu = useRef(null);
    const header = useRef(null);
    const {toggleMenu, ...menuProps} = useMenuState({transition: true});
    useEffect(() => {
            objeler.Header = {Height: header.current.clientHeight};
            const fullBtn = innerRef.current;
            const fullBtnExit = innerRefExit.current;
            fullBtn.addEventListener("click", fullsc);
            fullBtnExit.addEventListener("click", fullscExit);
            document.addEventListener('fullscreenchange', () => {
                if (document.fullscreenElement) {
                } else {
                    try {
                        innerRefExit.current.style.display = 'none';
                        innerRef.current.style.display = 'inline-block';
                    } catch {
                    }
                }
            });
            return () => {
                fullBtn.removeEventListener("click", fullsc);
                fullBtnExit.removeEventListener("click", fullscExit);
            };
        },
        [
            () => {
                objeler.Header = {Height: header.current.clientHeight}
            }
        ]);
    const fullscExit = () => {
        exitFullscreen();
        innerRefExit.current.style.display = 'none';
        innerRef.current.style.display = 'inline-block';
    }
    const LogoutOk = () => {

        if (!objeler.hasOwnProperty("User")) return

        console.log('logout', axiosInstance)
        axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/Logout', null
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                //responseType: 'arraybuffer'
            }
        ).then((response) => {
           // console.log('RES', response, store.getState().appReducers.SessionId)
            if (response.data === 'dublicate') {
                sessionStorage.clear();
                objeler.User = null;
                history.push({
                    pathname: '/'
                    , state: {redir: true}
                })
            }

        }).catch((error) => {

            sessionStorage.clear();
            objeler.User = null;
            history.push({
                pathname: '/'
                , state: {redir: true}
            })
        })


        objeler.Editor.CleanOk();
        exitFullscreen();
        objeler.Editor.redir();
        props.logout()
    }
    const logout = () => {
        const {alert} = props;
        toolRef.current.globalHide();
        alert.success('Your changes will be lost. Are you sure you want to quit?', true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            setTimeout(() => {
                                LogoutOk();
                            }, 500);
                        },
                    }
                ]
            }
        );
    }
    const saveScreenshot = (canvas) => {
        const fileName = "image";
        const link = document.createElement("a");
        link.download = fileName + ".png";
        console.log(canvas);
        canvas.toBlob(function (blob) {
            console.log(blob);
            link.href = URL.createObjectURL(blob);
            link.click();
        });
    }
    const screnShoot = () => {
        objeler.Editor.screnShoot();
        return;
        var edt = document.getElementById('editor');
        html2canvas(edt, {
            useCORS: true,
            taintTest: true,
            allowTaint: true,
            copyStyles: true,
            removeContainer: true
            ,
            onclone: function (clonedDoc) {
            }
            ,
        }).then((canvas) => {
            saveScreenshot(canvas);
        })
        return;
        html2canvas(edt, {
            onrendered: function (canvas) {
                document.body.appendChild(canvas);
            }
        }).then(saveScreenshot);
        ;
        return;
        html2canvas(c, {}).then(function (canvas) {
            document.body.appendChild(canvas);
            saveScreenshot(canvas)
        });
        return;
        html2canvas(document.body).then(function (canvas) {
            document.body.appendChild(canvas);
        });
        return;
        html2canvas($("#editor"), {
            onrendered: function (canvas) {
                theCanvas = canvas;
                document.body.appendChild(canvas);
                canvas.toBlob(function (blob) {
                    saveAs(blob, "Dashboard.png");
                    console.log('DASH', blob);
                });
            }
        });
    }
    const fullsc = (e) => {
        e.preventDefault();
        requestFullscreen(document.documentElement);
        innerRef.current.style.display = 'none';
        innerRefExit.current.style.display = 'flex';
        return;
        if (innerRef.current.innerHTML == "Full Screen") {
            e.preventDefault();
            requestFullscreen(document.documentElement);
            innerRef.current.innerHTML = "Exit Full Screen";
        } else {
            exitFullscreen();
            innerRef.current.innerHTML = "Full Screen";
        }
    }
    const requestFullscreen = (ele) => {
        if (ele.requestFullscreen) {
            ele.requestFullscreen();
        } else if (ele.webkitRequestFullscreen) {
            ele.webkitRequestFullscreen();
        } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
        } else if (ele.msRequestFullscreen) {
            ele.msRequestFullscreen();
        } else {
        }
    };
    const exitFullscreen = () => {
        if (document.exitFullscreen) {
            if (document.fullscreenElement !== null)
                document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            if (document.fullscreenElement !== null)
                document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            if (document.fullscreenElement !== null)
                document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            if (document.fullscreenElement !== null)
                document.msExitFullscreen();
        } else {
        }
    };
    return (
        <header ref={props.headerRef} rmthumb="1">
            <nav className="flex items-center justify-between flex-wrap bg-blue-dark p-1 shadow"
                 onMouseMove={(e) => {
                     e.stopPropagation();
                     setDocMenuState('closed'), setPageMenuState('closed')
                 }}
                 id="header"
                 ref={header}
            >
                <table
                    style={{width: '100%'}}
                >
                    <tbody>
                    <tr>
                        <td align="center"
                            style={{width: '10%'}}
                        >
                            <img
                                style={{height: '46px'}}
                                className="align-top"
                                srcSet={logo}
                                alt="PDF Designer"
                            />
                        </td>
                        <td style={{width: '5%'}}>
                        </td>
                        <td style={{width: '1%'}}>
                            <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto"
                                 onMouseMove={(e) => {
                                     e.stopPropagation();
                                 }}
                            >
                                <div
                                    className={'inline-block bg-customWhite text-sm px-4 py-2 leading-none border-btn  border-customGray    text-gray-600    hover:border-customGray1  hover:bg-blue-50 hover:bg-text-red mb-0 lg:mt-2 '}
                                    styles={{width: '30em', fontVariantLigatures: 'normal', height: '400px'}}
                                    ref={refDocMenu}
                                    onMouseEnter={(e) => {
                                        setPageMenuState('closed');
                                        setDocMenuState('opening');
                                    }
                                    }
                                    onMouseLeave={(e) => {
                                        e.stopPropagation();
                                    }}
                                    onMouseMove={(e) => {
                                        e.stopPropagation();
                                    }}
                                >Document
                                </div>
                                <ControlledMenu {...menuProps} anchorRef={refDocMenu} state={DocMenuState}
                                                transition={false} transitionTimeout={5000}
                                                onMouseLeave={() => setDocMenuState('closed')}
                                                onClose={() => setDocMenuState('closed')}
                                >
                                    {!isUUID(objeler.DocName) &&
                                    <React.Fragment>
                                    <MenuItem
                                        className={btnMenuItemClass}
                                        onClick={() => Clean()}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-file-alt text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>New</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={() => Open()}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-folder-open text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Open</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={() => SaveForce(false)}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-save text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Save</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>

                                    <MenuItem className={btnMenuItemClass} onClick={() => Save(false)}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-save text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Save As</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={() => SaveHtml(null, false)}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-download text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Download As Html</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={() => SaveHtml(null, true)}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-download text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Download As CsHtml</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>

                                    <MenuDivider/>
                                        </React.Fragment>}
                                    <MenuItem className={btnMenuItemClass} onClick={() => SaveForce(true)}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{display: 'inline-block', width: "24px"}}>
                                                    <img srcSet={pdficon} style={{width: '16px', height: '50%'}}/>
                                                </td>
                                                <td style={{width: '0px', height: '100%'}}>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Export Pdf</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuDivider/>
                                    <MenuItem className={btnMenuItemClass} onClick={() => Datasource()}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="fas fa-database text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Data Source</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={() => Doc()}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="fas fa-hammer text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Preferences</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                </ControlledMenu>
                                <div
                                    className={'inline-block bg-customWhite text-sm px-4 py-2 leading-none border-btn  border-customGray    text-gray-600    hover:border-customGray1  hover:bg-blue-50 hover:bg-text-red mb-0 lg:mt-2 '}
                                    styles={{width: '30em', fontVariantLigatures: 'normal', height: '400px'}}
                                    ref={refPageMenu}
                                    onMouseEnter={() => {
                                        setDocMenuState('closed');
                                        setPageMenuState('opening')
                                    }}
                                    onMouseMove={(e) => {
                                        e.stopPropagation();
                                    }
                                    }
                                >Page
                                </div>
                                <ControlledMenu {...menuProps} anchorRef={refPageMenu} state={PageMenuState}
                                                onMouseLeave={() => setPageMenuState('closed')}
                                                onClose={() => setPageMenuState('closed')}
                                                transition={false}
                                >
                                    <MenuItem className={btnMenuItemClass} onClick={props.NewPageClick}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-copy text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Add</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={props.InsertPageClick}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-file-import text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Insert</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass} onClick={() => {
                                        props.DeletePageClick(-1)
                                    }}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-trash-alt text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Delete</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuItem className={btnMenuItemClass}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="far fa-window-close text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Clean</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                    <MenuDivider/>
                                    <MenuItem className={btnMenuItemClass} onClick={() => Page()}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td style={{width: btnMenuIconWidth}}>
                                                    <i className="fas fa-hammer text-gray-600"
                                                       style={{fontSize: btnMenuIconSize}}/>
                                                </td>
                                                <td><p className={btnMenuTextClass}>Preferences</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </MenuItem>
                                </ControlledMenu>
                                <button 
                                    onClick={() => store.dispatch(openTemplateLibrary())}
                                    className={btnMenuClass}
                                    data-tip data-for="templateLibTip"
                                    style={{
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: 'white',
                                        border: 'none',
                                        fontWeight: '600'
                                    }}
                                >
                                    📚 Templates
                                </button>
                                <ReactTooltip id="templateLibTip" place="bottom" effect="solid"
                                              className={toolTipClass}
                                >
                                    Template Kütüphanesi
                                </ReactTooltip>
                                <button
                                    onClick={() => store.dispatch(openV2Dashboard())}
                                    className={btnMenuClass}
                                    data-tip data-for="v2PlatformTip"
                                    style={{
                                        background: 'linear-gradient(135deg, #4361ee 0%, #7209b7 100%)',
                                        color: 'white',
                                        border: 'none',
                                        fontWeight: '600'
                                    }}
                                >
                                    🚀 Platform
                                </button>
                                <ReactTooltip id="v2PlatformTip" place="bottom" effect="solid"
                                              className={toolTipClass}
                                >
                                    V2 Platform Dashboard
                                </ReactTooltip>
                            </div>
                        </td>
                        <td style={{width: '5%'}}>
                        </td>
                        <td style={{width: '20%'}}>
                            <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
                                <MenuButton
                                    className={btnZoomClass}
                                    onClick={() => props.ZoomIn(1)}>
                                    <i className="fas fa-search-plus text-gray-600 " style={{fontSize: '1.5em'}}/>
                                </MenuButton>
                                <MenuButton
                                    className={btnZoom100Class}
                                    styles={{height: '31px', width: '70px'}}
                                    onClick={() => props.ZoomIn(0)}>
                                    <p className="text-base font-normal  text-gray-600 font-sans ">%100</p>
                                </MenuButton>
                                <MenuButton
                                    className={btnZoomClass}
                                    onClick={() => props.ZoomIn(-1)}>
                                    <i className="fas fa-search-minus text-gray-600" style={{fontSize: '1.5em'}}/>
                                </MenuButton>
                                <div>
                                    <button id="fs-doc-button"
                                            className={btnZoomClassFullScreen}
                                            ref={innerRef}
                                            data-tip data-for="fullScreenTip"
                                    >
                                        <i className="fas fa-expand text-gray-600" style={{fontSize: '1.5em'}}/>
                                    </button>
                                    <ReactTooltip id="fullScreenTip" place="bottom" effect="solid"
                                                  className={toolTipClass}
                                    >
                                        Full Screen
                                    </ReactTooltip>
                                    <button id="fs-doc-buttonE"
                                            className={btnZoomClass}
                                            style={{display: 'none'}}
                                            ref={innerRefExit}
                                            data-tip data-for="exitfullScreenTip"
                                    >
                                        <i className="fas fa-compress text-gray-600" style={{fontSize: '1.5em'}}/>
                                    </button>
                                    <ReactTooltip id="exitfullScreenTip" place="bottom" effect="solid"
                                                  className={toolTipClass}
                                    >
                                        Restore Screen
                                    </ReactTooltip>
                                </div>
                            </div>
                        </td>
                        <td style={{width: '22%'}}>
                            <div
                                className="w-full block flex-grow lg:flex lg:items-center lg:w-auto whitespace-nowrap   ">
                  <span className="ml-2   text-gray-400     text-xs "
                        style={{fontFamily: 'raleway'}}>
                      Current (
                    <pre
                        style={{display: 'inline-flex', fontFamily: 'monospace', fontSize: '13px', overflow: 'hidden'}}
                    >
                      {props.ActivePageScroll}/{props.Pages.length}
                    </pre>)&nbsp;&nbsp;
                      <pre
                          style={{display: 'inline-flex', fontFamily: 'raleway', overflow: 'hidden'}}
                      >
                        {isUUID(objeler.DocName) ? "Demo" : objeler.DocName}

                    </pre>

                  </span>
                                {/*<input value={objeler.DocName}/>*/}
                            </div>
                        </td>
                        {/*
                          ─── M2: workspace badge ───
                          Shows the user's current account (workspace) name with a
                          person icon. Renders only when objeler.User.AccountName
                          is set — i.e. the user is on a fresh M2 token. Pre-M2
                          tokens fall back gracefully (no badge).

                          Why here? Industry standard for SaaS tools (Figma, Linear,
                          Notion) places workspace context next to the user actions
                          on the right side of the header. Reading order matches
                          the natural eye path: tools on the left, identity on the right.

                          Click handler is reserved for M2.5 (account switcher).
                          Until then, this is a read-only display element.
                        */}
                        {objeler.User && objeler.User.AccountName && (
                            <td style={{width: '15%', textAlign: 'right', paddingRight: '8px'}}>
                                <div
                                    className="inline-flex items-center text-gray-600"
                                    style={{
                                        fontSize: '0.85em',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}
                                    title={
                                        objeler.User.AccountName +
                                        (objeler.User.Role ? ' (' + objeler.User.Role + ')' : '')
                                    }
                                >
                                    <i
                                        className="fas fa-user-circle"
                                        style={{
                                            fontSize: '1.2em',
                                            marginRight: '6px',
                                            color: '#6b7280'
                                        }}
                                    />
                                    <span style={{maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                        {objeler.User.AccountName}
                                    </span>
                                </div>
                            </td>
                        )}
                        <td style={{width: '5%'}}>
                            <MenuButton
                                className={btnZoomClass}
                                href="/"
                                onClick={(e) => {
                                    setTimeout(() => {
                                        ReactTooltip.hide();
                                    }, 2000);
                                    logout();
                                }}
                                data-tip data-for="logoutTip"
                            >
                                <i className="fas fa-sign-out-alt text-gray-600" style={{fontSize: '1.5em'}}/>
                            </MenuButton>
                            <ReactTooltip id="logoutTip" place="bottom" effect="solid"
                                          className={toolTipClass}
                                          ref={toolRef}
                                          isCapture={true}
                            >
                                Logout
                            </ReactTooltip>
                        </td>
                        <td style={{width: '13%', marginRight: '0px'}}
                        >
                            <div className="w-full flex flex-grow  justify-end whitespace-nowrap "
                            >
                                <span className="ml-2   text-gray-600  lg:text-shadow-lg  font-bold text-base  "> Document Designer</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </nav>
        </header>
    );
}
export default withAlert()(Header);
